<template>
  <v-card
    class="mx-auto"
    min-height="125"
    max-height="125"
    @click="$emit('triggerFileInput')"
    v-cloak @drop.prevent="addDropFile" @dragover.prevent
    outlined
  >
    <v-card-text
      class="text-center py-7"
    >
      <v-icon>mdi-cloud-upload-outline</v-icon>
      <div class="caption">
        Drag and drop a file here or click here to browser your file
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    user: Object,
  },
  methods: {
    addDropFile(e) {
      this.$emit('addDropFile', e);
    },
  },
};
</script>
